import api from "./api.js";

export default class BannerApi {
  static async getInfo(data) {
    return await api.get(`api/banner`, data);
  }
}
